<template>
  <div>
    <video
      ref="video"
      :poster="require(`assets/img/${content.thumb}`)"
      class="video"
      controls
      playsinline="true"
      preload="auto">
      <source
        :src="require(`assets/videos/${content.src}`)"
        type="video/mp4">
    </video>
  </div>
</template>
<script>

import { trackVideo } from '../utils/track';

export default {
  props: {
    content: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$refs.video.addEventListener('play', this.onStartPlaying);
    this.$refs.video.addEventListener('pause', this.onPausePlaying);
    this.$refs.video.addEventListener('ended', this.onFinishedPlaying);
  },
  methods: {
    onStartPlaying() {
      trackVideo(this.content.name, 'play');
    },
    onPausePlaying() {
      trackVideo(this.content.name, 'pause');
    },
    onFinishedPlaying() {
      trackVideo(this.content.name, 'finished');
    },
  },
};
</script>
<style lang="scss" scoped>
  .video {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/VideoComponent.vue